export function persistPrismicTokens (url) {
  if (!window.location.pathname.startsWith('/prismic-preview')) return url

  const paramsToPersist = ['token', 'documentId', 'page_selection']
  const currentUrl = new URLSearchParams(window.location.search)
  const urlWithTokens = new URLSearchParams(url)

  paramsToPersist.forEach(param => {
    const value = currentUrl.get(param)
    if (value) urlWithTokens.set(param, value)
  })

  return '?' + urlWithTokens.toString()
}
